import React from 'react';
import { Eye } from 'lucide-react';
import ProjectTemplate from './ProjectTemplate';

const Vision = () => {
  const project = {
    title: 'Yamai Vision',
    tagline: 'Retinal Pattern Detection for Early Eye Disease Diagnosis',
    icon: Eye,
    color: '#8B5CF6',
    overview: 'Yamai Vision applies advanced computer vision to retinal fundus imaging, enabling early detection of diabetic retinopathy, glaucoma, age-related macular degeneration, and other vision-threatening conditions. Our explainable AI system helps ophthalmologists identify at-risk patients before irreversible vision loss occurs.',
    problems: [
      {
        title: 'Preventable Vision Loss',
        description: 'Many causes of blindness, like diabetic retinopathy, are preventable if caught early but often progress unnoticed.',
      },
      {
        title: 'Screening Capacity',
        description: 'There aren\'t enough ophthalmologists to screen all at-risk patients, especially diabetics who need regular eye exams.',
      },
      {
        title: 'Subtle Changes',
        description: 'Early retinal changes can be very subtle and difficult to detect without extensive experience.',
      },
      {
        title: 'Delayed Referrals',
        description: 'Patients are often referred to specialists only after significant damage has occurred.',
      },
    ],
    solutions: [
      'Automated detection of diabetic retinopathy at all severity levels (mild, moderate, severe, proliferative)',
      'Glaucoma risk assessment through optic disc analysis and cup-to-disc ratio calculation',
      'Macular degeneration detection including drusen identification',
      'Blood vessel abnormality detection (hemorrhages, microaneurysms, neovascularization)',
      'Explainable visualizations highlighting specific retinal regions showing pathological changes',
    ],
    technology: 'Yamai Vision employs deep convolutional neural networks specifically optimized for retinal image analysis. Our models are trained on diverse, multi-ethnic datasets to ensure equitable performance. The explainability layer uses attention maps and segmentation overlays to show ophthalmologists exactly which retinal features (lesions, vessel changes, optic disc abnormalities) led to the diagnostic classification.',
    roadmap: [
      {
        title: 'Model Development & Training (2026)',
        description: 'Build robust models using large-scale retinal imaging databases',
      },
      {
        title: 'Clinical Validation Studies (2027)',
        description: 'Partner with eye clinics for prospective validation in real screening programs',
      },
      {
        title: 'Telemedicine Integration (2028)',
        description: 'Develop platform for remote diabetic retinopathy screening',
      },
      {
        title: 'Market Launch (2029)',
        description: 'Deploy in diabetes clinics and primary care settings for frontline screening',
      },
    ],
  };

  return <ProjectTemplate project={project} />;
};

export default Vision;